import { useEffect } from "react";
import { Spacer } from "@qivia/ui";
import Car from "@qivia/ui/src/designSystem/assets/Car.png";
import styled from "styled-components";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { selectCompany } from "../routes/home/homeSlice";
import {
  carIconPresignedUrlAsync,
  listAllVehiclesInDbAsync,
  selectCarIconPresignedUrl,
  selectCarIconPresignedUrlStatus,
  selectListAllVehiclesInDb,
  selectListAllVehiclesInDbStatus,
  vehiclesSlice,
} from "../routes/home/vehicles/vehiclesSlice";

export const VehicleCarIcon = (props: {
  registrationNumber: string | null;
}) => {
  const dispatch = useAppDispatch();
  const company = useAppSelector(selectCompany);
  const vehicles = useAppSelector(selectListAllVehiclesInDb);
  const listAllVehiclesInDbStatus = useAppSelector(
    selectListAllVehiclesInDbStatus,
  );
  const carIconPresignedUrl = useAppSelector(selectCarIconPresignedUrl);
  const carIconPresignedUrlStatus = useAppSelector(
    selectCarIconPresignedUrlStatus,
  );

  useEffect(() => {
    if (company && listAllVehiclesInDbStatus === "idle") {
      void dispatch(listAllVehiclesInDbAsync({ companyUuid: company.uuid }));
    }
  }, [company, dispatch, listAllVehiclesInDbStatus]);

  const bucketFileName =
    vehicles.find((v) => v.registrationNumber === props.registrationNumber)
      ?.carIconBucketFileName ?? null;

  useEffect(() => {
    dispatch(vehiclesSlice.actions.resetCarIconPresignedUrl());
  }, [bucketFileName, dispatch]);

  useEffect(() => {
    if (bucketFileName && carIconPresignedUrlStatus === "idle") {
      void dispatch(carIconPresignedUrlAsync({ bucketFileName }));
    }
  }, [bucketFileName, carIconPresignedUrlStatus, dispatch]);

  const isVehiclesListLoading =
    listAllVehiclesInDbStatus === "idle" ||
    listAllVehiclesInDbStatus === "processing";

  const isCarIconLoading =
    isVehiclesListLoading ||
    (!!bucketFileName &&
      !carIconPresignedUrl &&
      carIconPresignedUrlStatus !== "failed");

  return (
    <>
      <Spacer y={1} />
      {isCarIconLoading ? (
        <Spacer y={6.5} />
      ) : (
        <StyledImg
          src={carIconPresignedUrl ?? Car}
          alt="Car"
          $isDefaultCarIcon={!carIconPresignedUrl}
          onError={() =>
            dispatch(vehiclesSlice.actions.setCarIconPresignedUrlFailed())
          }
        />
      )}
    </>
  );
};

const StyledImg = styled.img<{ $isDefaultCarIcon: boolean }>`
  filter: ${({ $isDefaultCarIcon }) =>
    $isDefaultCarIcon ? "grayscale(100%)" : "none"};
  width: 15rem;
  height: 6.5rem;
  object-fit: contain;
  transform: ${({ $isDefaultCarIcon }) =>
    $isDefaultCarIcon ? "none" : "scale(1.7)"};
`;
